"use strict";

module.exports = function(config, get, post){
	return {
		listType,
		add,
		remove
	};

	function listType(type){
		return get("/v2/exportpreset/listType", {
			type
		});
	}

	function add(name, description, type, options){
		return post("/v2/exportpreset/add", {
			name,
			description,
			type,
			options
		});
	}

	function remove(preset){
		return post("/v2/exportpreset/remove", {
			preset
		});
	}
};